// ユーザの削除

$(() => {
    if (document.getElementById('user-delete-form') != null) {
        // アクター取得
        const actor = location.pathname.split("/")[1];
        const user_id = location.pathname.split('/')[4];
        // ajax設定
        $.ajaxSetup({
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        });
        // 登録処理
        $('#submit').on('click', function() {
            $('#submit').prop('disabled', true);
            $.ajax({
                type: 'POST',
                url: '/' + actor + '/delete_' + actor + '_user',
                data: {
                    'actor': actor,
                    'user_id' : user_id
                },
                dataType : 'json'
            }).done(function(data) {
                if (data.success) {
                    $('#user-delete-modal').modal('hide');
                    alert('ユーザを完全に削除しました。');
                    window.location.href ='/' + actor + '/company/users';
                }
                else {
                    if (data.error) {
                        data.error.forEach(function(element) {
                            $('#user-delete-modal').find('#errors').append('<div class="alert alert-danger" role="alert">' + element + '</div>');
                        });
                    }
                    else {
                        $('#user-delete-modal').modal('hide');
                    }
                }
            }).fail(function(XMLHttpRequest, textStatus, error) {
                alert('ユーザの削除に失敗しました。');
                $('#submit').prop('disabled', false);
            });
        });
    }
});
